var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.83301 24.5H22.1663","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13.9997 18.6667L9.33301 14.2431M13.9997 3.5V18.6667V3.5ZM13.9997 18.6667L18.6663 14.2431L13.9997 18.6667Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Download.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","color":"currentColor","fill":"none"};

module.exports = Download;

Download.default = Download;
